export interface ExternalBaseContractAddresses {
  readonly utbExecutor: `0x${string}`;
  readonly doodlesCertifiedViral: `0x${string}`;
  readonly doodlesComics: `0x${string}`;
}

const _registry: Record<string, ExternalBaseContractAddresses> = {
  mainnet: {
    utbExecutor: '0x777e05D02Ea7B42F32f103c089C175017082f531',
    doodlesCertifiedViral: '0xFE9117d6D0b973faaE61D9a85A741CE41bd4BC80',
    doodlesComics: '0x727dDd8D560E51d7Ab2291Eae6A2B35455DF8592',
  },
  sepolia: {
    utbExecutor: '0x1319A5EEA1d57C93Bc3Bf602e9EFbD2144C8526f',
    doodlesCertifiedViral: '0x',
    doodlesComics: '0x',
  },
};

let _selectedNetwork: ExternalBaseContractAddresses;

switch (process.env.NEXT_PUBLIC_APP_ENV) {
  case 'production':
    _selectedNetwork =
      _registry.mainnet ?? ({} as ExternalBaseContractAddresses);
    break;
  default:
    _selectedNetwork =
      _registry.sepolia ?? ({} as ExternalBaseContractAddresses);
    break;
}

export const externalBaseContractAddresses =
  _selectedNetwork as Readonly<ExternalBaseContractAddresses>;
